import { ApiServiceBase } from './ApiServiceBase'
import type { LocationQueryValue } from 'vue-router'

type Query = {
  filter?: string | LocationQueryValue[]
  perPage?: number | LocationQueryValue[]
  page?: number
}

export default class extends ApiServiceBase {
  async index(query: Query) {
    return useAsyncData('approaches-index', () => this.call('/spa/approaches', { query: query }))
  }

  async show(id: number) {
    return useAsyncData('approaches-show', () => this.call(`/spa/approaches/${id}`))
  }

  async store(influencers: string, category?: number): Promise<any> {
    return await this.call('/spa/approaches', {
      method: 'post',
      body: { influencers, category },
    })
  }

  async update(id: number, data: any): Promise<any> {
    return await this.call(`/spa/approaches/${id}`, {
      method: 'put',
      body: {
        ...data,
        influencer_category: data.influencer_category?.id,
      },
    })
  }

  async batchDiscard(approachIds: number[]): Promise<any> {
    return await this.call('/spa/approaches/batch', {
      method: 'delete',
      body: {
        approaches: approachIds,
      },
    })
  }

  async batchExtensionInfluencers(data: any): Promise<any> {
    return await this.call('/spa/approaches/extension', {
      method: 'delete',
      body: {
        influencers: data,
      },
    })
  }

  async removeMonitoredInfluencer(id: number) {
    return await this.call(`/spa/approaches/monitored/${id}`, {
      method: 'delete',
    })
  }
}
